import { useMutation, useQueryClient, useQuery } from 'react-query';
import { createMenu, uploadFile, downloadTemplate, getExistsMenu } from 'components/MenuMakeImport/services';

export const useCreateMenu = () => {
  return useMutation({
    mutationFn: createMenu,
  });
};

export const useUploadFile = () => {
  return useMutation({
    mutationFn: uploadFile,
  });
};

export const useDownloadTemplate = () => {
  return useMutation({
    mutationFn: downloadTemplate,
  });
};

export const useGetExistsMenu = () => {
  return useMutation({
    mutationFn: getExistsMenu,
  });
};

export const useImportMenuModal = () => {
  const queryClient = useQueryClient();
  const { data: isOpen = false } = useQuery({
    queryKey: ['importMenuModal'],
    queryFn: () => false,
    staleTime: Infinity,
  });

  const handleOpen = () => {
    queryClient.setQueryData(['importMenuModal'], true);
  };

  const handleClose = () => {
    queryClient.setQueryData(['importMenuModal'], false);
  };

  return {
    handleOpen,
    handleClose,
    importMenuModalIsOpen: isOpen,
  };
};
